import { OptionGroup, StorageDTO } from 'interfaces';
import { sortOptions } from 'utils/functions/sortOptions';
import { translate } from 'utils/translate';

import { parseStorageDTOIntoOption } from './parseStorageDTOIntoOption';

export const parseStorageDTOsIntoOptionGroups: (
   storageDTOs: StorageDTO[],
) => OptionGroup[] = storageDTOs => {
   const storageOptionGroups: OptionGroup[] = [];
   const externalStorages = storageDTOs.filter(storage => storage.type === 'EXTERNAL');
   const internalStorages = storageDTOs.filter(storage => storage.type === 'INTERNAL');

   if (externalStorages.length) {
      const externalStorageOptions = externalStorages.map(parseStorageDTOIntoOption);
      const sortedExternalStorageOptions = sortOptions(externalStorageOptions);
      storageOptionGroups.push({
         groupName: translate('storage_point_type.external_storage'),
         options: sortedExternalStorageOptions,
      });
   }

   if (internalStorages.length) {
      const internalStorageOptions = internalStorages.map(parseStorageDTOIntoOption);
      const sortedInternalStorageOptions = sortOptions(internalStorageOptions);
      storageOptionGroups.push({
         groupName: translate('storage_point_type.internal_storage'),
         options: sortedInternalStorageOptions,
      });
   }

   return storageOptionGroups;
};
